import React from 'react'
import { css as hcss, keyframes } from '@emotion/css'

type Props = {}

const PagilyBouncing: React.FC<Props> = ({}) => {

    const blockAnimContent = hcss`
    position : absolute ;
    top : 35px;  
    left : 10%; 
     @media(max-width : 1400px){
       left : 5%;
     }   
     @media(max-width : 960px){
      display  : none;
    } 
    `
  const bouncing = keyframes`
    0% {
        -webkit-transform: translateY(-150px);
                transform: translateY(-150px);
        -webkit-animation-timing-function: ease-in;
                animation-timing-function: ease-in;
      }
      100% {
        -webkit-transform: translateY(0);
                transform: translateY(0);
        -webkit-animation-timing-function: ease-out;
                animation-timing-function: ease-out;
      }`
  const imgContent = hcss`
    width: 150px;
    height: 150px;
    display : block;
    margin: 200px auto 0;
    animation: ${bouncing} 800ms infinite alternate;
    animation-delay: 0;
    `
  const shadowAnimation = keyframes`
    0%{
        transform: scale(0.8);
        opacity : .3;     
        -webkit-animation-timing-function: ease-in;
                animation-timing-function: ease-in;
      }
        100% {
            transform: scale(0); 
            opacity:.1; 
            -webkit-animation-timing-function: ease-in;
            animation-timing-function: ease-in;}
    }
    `
  const shadow = hcss`
    width: 150px;
    height: 20px;
    border-radius: 50%;
    background-color: black;
    display:block;
    margin: 0 auto;
    position: relative;
    top: -25px;
    opacity: 0.3;
    animation: ${shadowAnimation} 800ms infinite alternate;
    animation-delay: 0;
    filter: blur(10px);
    
    `
  return (
    <div className={blockAnimContent}>
      <img
        src="../../img/demo/pagily_love.svg"
        alt="Bêta-test Pagily"
        className={imgContent}
      />
      <span className={shadow}></span>
    </div>
  )
}

export default PagilyBouncing
